import React from 'react';
import { ImageBj } from '@components/common';
import bestieImage from '@images/agent/bestie-white-bg.png';
import { useTranslation } from 'next-i18next';

interface InterviewerBiaProps {
  description?: string;
}

/**
 * @description InterviewerBia component.
 * Displays the avatar of the AI interviewer Bia with a pulsing background effect.
 *
 * @param {InterviewerBiaProps} props - The properties for the component.
 * - **description**: string (optional) - Description text to display below the avatar.
 */
export const InterviewerBia = (props: InterviewerBiaProps) => {
  const { t } = useTranslation('common');
  const { description = t('ai.interview.interviewer.listening') } = props;

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      <div className="relative flex size-14 items-center justify-center">
        <div className="absolute inline-flex size-16 animate-size-pulse rounded-full bg-secondary/15" />
        <div className="relative size-14 overflow-hidden rounded-full border-2 border-secondary">
          <ImageBj
            alt="Interviewer Bestie"
            src={bestieImage}
            className="size-full object-cover"
          />
        </div>
      </div>
      <p className="text-tiny text-ink-light">{description}</p>
    </div>
  );
};
